module.exports = /*html*/ `
<div class="shop-inner-content">
    <div class="loading-mask" :class="{'active':!dataIsLoad}"></div>
    <ArrivalNotice :custommarketid="CMID"></ArrivalNotice>
    <div class="photo-content col-12 col-lg-9">
        <Photo :dataisload="dataIsLoad" :selected="selectedData" :alldatas="itemDatas" :changeImage="changePic"
            :showMobile="false" />
    </div>
    <div class="info-content col-12 col-lg-3">
        <Spec :dataisload="dataIsLoad" :selected="selectedData" :alldatas="itemDatas" :hasstock="hasStock"
            v-on:change-selected="changeSelected" v-on:change-slideindex="changeNowSlideIndex"
            v-on:changecmid="handleCMID" />
    </div>
    <div class="d-lg-none photo-content col-12">
        <Photo :dataisload="dataIsLoad" :selected="selectedData" :alldatas="itemDatas" :changeImage="changePic"
            :showMobile="true" />
    </div>
    <div class="d-lg-none col-12">
        <AddonShop :marketID="CustomMarketID.substring(0, CustomMarketID.indexOf('CL'))" />
    </div>
    <div class="col-12 col-lg-10">
        <Recommend :alldatas="itemDatas" />
    </div>
    <SizeChart :dataisload="dataIsLoad" :alldatas="itemDatas" />
    <cartDialog ref="c_favorite" :isnotice="''" @changecmid="handleCMID" />
</div>
`;
